import styled from 'styled-components'

export const ContentContainer = styled.div(
  ({ theme, removeLeftMargins }) => `
width: 100%;
min-height: 100vh;
display: flex;
flex-direction: column;
padding-left: ${removeLeftMargins ? 'unset' : '70px'};
padding-right: 16px;
background: #FAFAFA;
@media (min-width: 768px){
  padding-left: ${removeLeftMargins ? 'unset' : '100px'};
  padding-right: 24px;
}

@media print {
  padding-left: 0;
  padding-right: 0;
  background: transparent;
}
`,
)
